import {
    CONFIRMORDER_REQUEST,
    CONFIRMORDER_SUCCESS,
    CONFIRMORDER_ERROR,
    ORDERSTATUS_CLEAR,

    SIGNATURE_REQUEST,
    SIGNATURE_SUCCESS,
    SIGNATURE_ERROR,
    SIGNATURESTATUS_CLEAR,
    SIGNATURE_params,
} from "../actions/confirmOrder";
import { POSTCOMPARTMENTS_params } from "../actions/compartments";
import apiCalls from "utils/api";

const state = {
    confirmOrderStatus: "",
    SignatureStatus: "",
};

const getters = {
    isRequestSending: state => state.confirmOrderStatus == "loading",
    getConfirmOrderStatus: state => state.confirmOrderStatus,
    getSignatureStatus: state => state.SignatureStatus
};

const actions = {
    [CONFIRMORDER_REQUEST]: ({ commit, dispatch }, data) => {
        debugger;
        commit(CONFIRMORDER_REQUEST);
        commit(SIGNATURE_REQUEST);
        var orderData = data.order.map(m => {
            return {
                shipmentId: m.ShipmentId,
                dimensionId: m.DimensionId,
                tripLine: data.tripLineId,
                quantity: m.Quantity,
                type: 0,
                product: m.ProductId,
                delnote: m.ShipmentDimDelNote
            }
        });
        var returnData = data.returnGoodsList.map(m => {
            return {
                shipmentId: data.shipmentId,
                dimensionId: "",
                tripLine: data.tripLineId,
                quantity: m.Quantity,
                type: 1,
                product: m.ObjectId
            }
        });
        var extraData = data.extraList.map(m => {
            return {
                shipmentId: data.shipmentId,
                dimensionId: "",
                tripLine: data.tripLineId,
                quantity: m.Quantity,
                type: 30,
                product: m.ObjectId
            }
        });

        var dimensions = orderData.concat(returnData).concat(extraData);
        var result = {
            shipmentId: data.shipmentId,
            compartments: data.compartments,
            dimensions: dimensions,
            signature: data.signature
        }
        //commit(SIGNATURE_REQUEST);

        apiCalls.apiCall2({ url: "post", method: "POST", data: result, params: POSTCOMPARTMENTS_params })
            .then(resp => {
                commit(CONFIRMORDER_SUCCESS);
                commit(SIGNATURE_SUCCESS);
            })
            .catch(() => {
                commit(CONFIRMORDER_ERROR);
                commit(SIGNATURE_ERROR);
            });

    }
};

const mutations = {
    [CONFIRMORDER_REQUEST]: state => {
        state.confirmOrderStatus = "loading";
    },
    [CONFIRMORDER_SUCCESS]: (state, resp) => {
        state.confirmOrderStatus = "success";
    },
    [CONFIRMORDER_ERROR]: state => {
        state.confirmOrderStatus = "error";
    },
    [ORDERSTATUS_CLEAR]: state => {
        state.confirmOrderStatus = "";
    },

    [SIGNATURE_REQUEST]: state => {
        state.SignatureStatus = "loading";
    },
    [SIGNATURE_SUCCESS]: (state, resp) => {
        state.SignatureStatus = "success";
    },
    [SIGNATURE_ERROR]: state => {
        state.SignatureStatus = "error";
    },
    [SIGNATURESTATUS_CLEAR]: state => {
        state.SignatureStatus = "";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
